import { mapSiteDtoToModel } from '@hotjar/site';
import { mapOrganizationDtoToModel } from '@hotjar/organization';
import { launchHelp } from '@hotjar/webapp/help/launch';
import {
    goToCreateCSMTicketForm,
    goToCreateNewTicket,
    goToKnowledgeBase,
    goToNewBillingPaymentTicketForm,
    goToNewTicketHelp,
    openChat
} from '@hotjar/webapp/help/actions';

/**
 * Help related functionality.
 */
angular.module('hjApp').service('Help', function (ModalGrantSupportAccess, UserData) {
    /*************************
     * PRIVATE FUNCTIONS
     *************************/
    /**
     * Transforms `UserData.currentSite` into a version similar to the new `Site` model in the React code base
     * TODO: remove this when updating the utility methods to find the current site directly
     */
    function currentSiteModel() {
        const currentSite = UserData.currentSite;

        if (currentSite.id && currentSite.organization) {
            const organization = mapOrganizationDtoToModel(currentSite.organization);

            return mapSiteDtoToModel(currentSite, [organization]);
        }
    }

    /*************************
     * SERVICE METHODS
     *************************/
    /**
     * Launch help.
     */
    this.launch = () => {
        launchHelp(UserData.get('userId'), currentSiteModel(), (done) => {
            // N.B. if the intention is to go to help regardless of access, we should call `done` here in `finally`
            // instead of `then`.
            ModalGrantSupportAccess.show().result.then(done).catch(_.noop);
        }).catch(_.noop);
    };

    /**
     * Go to knowledgebase.
     */
    this.goToKnowledgeBase = () => goToKnowledgeBase(currentSiteModel());

    /**
     * Go to the new ticket form.
     */
    this.newTicket = () => goToCreateNewTicket(currentSiteModel());

    /**
     * Go to the help page
     */
    this.newTicketHelpPage = () => goToNewTicketHelp(currentSiteModel());

    /**
     * Go to the new CSM ticket form.
     */
    this.newCSMTicket = () => goToCreateCSMTicketForm(currentSiteModel());

    /**
     * Go to the new Billing and Payment ticket form.
     */
    this.newBillingPaymentTicket = (source) => goToNewBillingPaymentTicketForm(source, currentSiteModel());

    this.openChat = (fallbackFunc, fallbackParams = null) => openChat(this[fallbackFunc], fallbackParams);
});
